import { enumBoxShapes, kMiniTriWidth, kTriAnnoW } from "../constants";
import { XML_AddPair } from "./XML_AddPair";
import { XML_AdjustLineWidth } from "./XML_AdjustLineWidth";
import { XML_Cmd1 } from "./XML_Cmd1";
import { XML_CreateTriPath } from "./XML_CreateTriPath";
import { XML_GetDashParam } from "./XML_GetDashParam";
import { XML_Scale } from "./XML_Scale";
import { XML_Cmd4 } from "./XML_Cmd4";
import { XML_Cmd2 } from "./XML_Cmd2";

export function XML_DrawTriPDF(
  bounds,
  boxShape,
  borderThickness,
  triColor,
  triPosition,
  borderColor,
  dashColor,
  subTriColor,
  drawElement,
  layer
) {
  var r = bounds;
  var adjL = XML_AdjustLineWidth(borderThickness, drawElement, layer) / 2;
  var tSize = XML_Scale(kTriAnnoW, drawElement, layer);
  var posRight = triPosition == 0;

  r.fBottom = r.fTop - tSize;
  r.fTop = r.fTop - adjL;
  var isy = r.fTop;
  var iey = r.fBottom;
  var isx, iex;

  r.fRight = posRight ? r.fRight - adjL : r.fLeft + tSize;
  r.fLeft = posRight ? r.fRight - tSize : r.fLeft + adjL;

  isx = r.fLeft;
  iex = r.fRight;

  if (triColor != null) {
    XML_CreateTriPath(isx, isy, iex, iey, r.fCornerRadius, boxShape, triPosition, drawElement);
    XML_Cmd1("fi", triColor, drawElement);
  }

  if (subTriColor != null) {
    var t2 = XML_Scale(kMiniTriWidth, drawElement, layer);
    var isy2 = isy - t2;
    var isx2 = isx;
    var iex2 = iex;

    if (posRight) isx2 = isx + t2;
    else iex2 = iex - t2;

    XML_CreateTriPath(isx2, isy2, iex2, iey, 0, enumBoxShapes.rectangle, triPosition, drawElement);
    XML_Cmd1("fi", subTriColor, drawElement);
  }

  var hypoColor = borderColor;
  var hypoThickness = 1;
  var dashed = false;
  var hsx = posRight ? isx : iex;
  var hex = posRight ? iex : isx;
  var hsy = isy;
  var hey = iey;

  if (dashColor != null) {
    hsx = posRight ? hsx + 1 : hsx - 1;
    hex = posRight ? hex - 1 : hex + 1;
    hsy = hsy - 1;
    dashed = true;
    hypoThickness = 2;
    hypoColor = dashColor;
  }

  var s = drawElement.GetStream();
  drawElement.OutputElementHead(s, "li");
  XML_AddPair(hsx, hsy, "mt", drawElement);
  XML_AddPair(hex, hey, "lt", drawElement);
  drawElement.OutputElementTail(s, "li");

  if (dashed) {
    var p = XML_GetDashParam(hypoThickness);
    XML_Cmd4("stk", hypoColor, hypoThickness, p.fX, p.fY, drawElement);
  } else XML_Cmd2("stk", hypoColor, hypoThickness, drawElement);
}
